import PropTypes from 'prop-types';
const ItemsInOrderTableImage = ({
  name,
  url,
  height = '24px',
  width = '24px'
}) => (
  <picture>
    <img
      src={`${url}?$pcc-cart$`}
      width={width}
      height={height}
      loading="lazy"
      alt={name}
    />
  </picture>
);

ItemsInOrderTableImage.propTypes = {
  height: PropTypes.string,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  width: PropTypes.string
};

export default ItemsInOrderTableImage;
